<template>
	<v-chart :option="getRadarData(score)" autoresize style="height: 300px" />
</template>

<script>
import { RadarChart } from 'echarts/charts'
import { PolarComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from 'vue-echarts'

use([CanvasRenderer, RadarChart, PolarComponent, TitleComponent, TooltipComponent])
provide(THEME_KEY, 'dark')

export default {
	name: 'CuppingScoreCard',
	components: {
		VChart
	},
	props: {
		score: Object
	},
	data() {
		return {
			dimensions: [
				// { name: '香气', field: 'fragrance', max: 10 },
				// { name: '风味', field: 'flavor', max: 10 },
				// { name: '酸度', field: 'acidity', max: 10 },
				// { name: '醇厚', field: 'body', max: 10 },
				// { name: '平衡', field: 'balance', max: 10 },
				// { name: '余韵', field: 'aftertaste', max: 10 },
				// { name: '甜度', field: 'sweetness', max: 10 },
				// { name: '干净', field: 'cleancup', max: 10 },
				// { name: '一致性', field: 'uniformity', max: 10 },
				// { name: '整体', field: 'overall', max: 10 }
				//
				{ name: '干香', field: 'aroma', max: 15 },
				{ name: '湿香', field: 'fragrance', max: 15 },
				{ name: '风味', field: 'flavor', max: 15 },
				{ name: '余韵', field: 'aftertaste', max: 15 },
				{ name: '酸质', field: 'acidity', max: 15 },
				{ name: '甜感', field: 'sweetness', max: 15 },
				{ name: '口感', field: 'body', max: 15 }
			]
		}
	},
	computed: {
		max() {
			return this.dimensions.reduce((acc, curr) => acc + curr.max, 0)
		},
		total() {
			const values = this.dimensions.map(({ field }) => this.score[field])
			return values.reduce((acc, curr) => acc + curr, 0)
		}
	},
	methods: {
		showScoreDetail() {
			this.$emit('showScoreDetail', this.score)
		},
		getRadarData() {
			const values = this.dimensions.map(({ field }) => this.score[field])
			return {
				// title: {
				// 	text: '总分：' + this.total + '/' + this.max,
				// 	top: '5%',
				// 	left: '5%'
				// },
				textStyle: {
					fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
					fontWeight: 300
				},
				radar: {
					indicator: this.dimensions.map(({ name, max }) => ({ name, max }))
				},
				series: [
					{
						name: 'Value',
						type: 'radar',
						data: [
							{
								value: values
							}
						]
					}
				]
			}
		}
	}
}
</script>

<style scoped></style>
